import axios, { Axios } from "axios";

import { Config } from "@/utils/config.utils";

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
const language = (() => {
    if (typeof window === "undefined") {
        return "en-US";
    }

    if (navigator.languages?.length) {
        return navigator.languages[0];
    }

    return navigator.language || (navigator as any).userLanguage;
})();

export const create = (endPoint: string = ""): Axios => {
    const API_BASE = Config.general["api-base-url"];
    if (!API_BASE) throw new ReferenceError("NO API DEFINED");

    return axios.create({
        baseURL: `${API_BASE}${endPoint}`,
        withCredentials: true,
        headers: {
            "Content-Type": "application/json",
            "Accept-Language": language,
            LANGUAGE: Config.getLocale()
        },
        validateStatus: (status) => status >= 200 && status < 400
    });
};

const createExternal = (): Axios => {
    return axios.create({
        withCredentials: false,
        headers: {
            "Content-Type": "application/json"
        },
        validateStatus: (status) => status >= 200 && status < 400
    });
};

export const ExternalAPI: Axios = createExternal();
